import { useTranslation } from "react-i18next";

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const set = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem("lang", lng);
  };
  const cur = i18n.language?.startsWith("en") ? "en" : "it";
  return (
    <div data-testid="language-switcher" className="flex items-center text-xs font-semibold tracking-widest">
      <button
        data-testid="lang-it"
        onClick={() => set("it")}
        className={`px-2 py-1 transition-colors ${cur === "it" ? "text-stone-900" : "text-stone-400 hover:text-stone-700"}`}
      >
        IT
      </button>
      <span className="text-stone-300">/</span>
      <button
        data-testid="lang-en"
        onClick={() => set("en")}
        className={`px-2 py-1 transition-colors ${cur === "en" ? "text-stone-900" : "text-stone-400 hover:text-stone-700"}`}
      >
        EN
      </button>
    </div>
  );
}
